<template>
  <DialogTemplate :show-controls="false" class="dialog">
    <FeedTabSelect
      :current-type="currentType"
      @select="(type) => select(type)"
    />
    <div v-if="feeds.length > 0" class="feed-wrapper">
      <ul class="scrollable">
        <FeedView
          :to-dayfeeds="toDayfeeds"
          :last7-days-feeds="last7DaysFeeds"
          :last30-days-feeds="last30DaysFeeds"
          :other-feeds="otherFeeds"
        />
      </ul>
    </div>
    <FeedBlockEmpty v-else />
  </DialogTemplate>
</template>
<script setup lang="ts">
interface Props {
  type?: 'all' | 'self' | 'following';
}

const props = defineProps({
  type: { default: 'self' }
});

const feedStore = useFeedStore();

const {
  toDayfeeds,
  last7DaysFeeds,
  last30DaysFeeds,
  otherFeeds,
  feeds,
  select,
  type: currentType,
} = useFeedView(props.type);
</script>
<style lang="scss" scoped>
.dialog {
  padding: var(--gap_m) var(--stroke_thickness_m);

  :deep(.dialog-content) {
    gap: 0;
  }
}
.feed-wrapper {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;

  --tab_height: 4rem;

  max-height: calc(
    100dvh - var(--header_height) - var(--footer_height) - var(--row_gap) -
      var(--row_gap) - var(--row_gap) - var(--tab_height)
  );

  .scrollable {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 var(--gap_n) 0 var(--gap_n);
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 0.5rem;
    }
    &::-webkit-scrollbar-thumb,
    &::-webkit-scrollbar-track {
      border-radius: 0.25rem;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--color_secondary_lighter);
    }

    &::-webkit-scrollbar-track {
      background: var(--color_neutral_25);
    }
  }

  padding: 0;
  gap: 1rem;
}
</style>
